<template lang="html">

  <div :show="show">



    <header>

      

      <router-link to="/" class="contenedor-logo">
        <img src="/static/img/logo.png" alt="Logo Carretilla" >
      </router-link>
      

    </header>

 
    <nav class="menu row-between aifs">

      <button class="open" @click="show = !show">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <button class="close" @click="show = !show">✕</button>

      <div class="opciones row-center">
          <router-link class="menu-el" router-link-exact-active to="/">Inicio</router-link>
          <router-link class="menu-el -dorado" router-link-exact-active :active="$route.path.includes($t('enlaces.recetas'))" :to="$t('enlaces.recetas')">Nuestras Recetas</router-link>
      </div>

    </nav>

  </div>

</template>

<script lang="js">
  export default  {
    name: 'app-header',
    props: [],
    mounted() {
      this.minLogo();
      $(window).scroll(e => {
        this.minLogo();
      });
    },
    data() {
      return {
          show : false
      }
    },
    methods: {
      minLogo : function(){
        var scroll = $(window).scrollTop();
        (scroll >= 100) ? $("header").addClass('min') : $("header").removeClass('min');
      },
      closeMenu : function(){
        this.show = false;
      },
      openMenu : function(){
        this.show = true;
      }
    },
    watch: {
      '$route' : function(){
        this.show = false;
      }
    }
  }
</script>

<style scoped>
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  display: inline-block;
  z-index: 10;
  transform: translateY(-190px);
  animation-name: downMenu;
  animation-delay: 0.5s;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  pointer-events: none;
}

@keyframes downMenu {
  to {
    transform: translateY(0);
  }
}

header .contenedor-logo {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%) translateY(-110%);
  display: block;
  transition: 0.5s;
  width: 230px;
  animation-name: downLogo;
  animation-delay: 1s;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
  pointer-events: visible;
}

@keyframes downLogo {
  to {
    transform: translateX(-50%) translateY(0%);
  }
}

header.min .contenedor-logo {
  width: 161px;
}

header .contenedor-logo img {
  display: block;
  transition: 1s;
  width: 100%;
}

.menu {
  position: fixed;
  left: 20px;
  top: 20px;
  z-index: 10;
  transition: 1s;
  will-change: transform;
  overflow: hidden;
}

.menu .opciones {
  height: 50px;
  transform: translateX(-264%);
  margin-left: 50px;
  transition: 1s;
}

[show="true"] .menu .opciones {
  transform: translateX(0%);
  height: 100%;
}

.menu-el {
  width: auto;
  height: 50px;
  line-height: 50px;

  padding: 0 20px;
  display: inline-block;
  color: #fff;
}

.menu-el:first-of-type {
  margin: 0 10px;
  background: rgba(32, 44, 84, 0.95);
}

.menu-el.-dorado {
  background: #967842;
  margin: 0 10px;
}

.menu-el.router-link-exact-active,
.menu-el[active="true"] {
  font-weight: 800;
  border: 1px solid white;
}

.menu-el.router-link-exact-active::before,
.menu-el[active="true"]::before {
  font-weight: 800;
  border: 1px solid white;
}

.close,
.open {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 1);
  border: none;
  font-size: 30px;
  line-height: 50px;
  pointer-events: visible;
  cursor: pointer;
  transition: 1s;
  outline: none;
  z-index: 5;
}

.open span {
  width: 40px;
  height: 3px;
  background: #967842;
  display: inline-block;
  position: absolute;
  left: 5px;
}

.open span:first-of-type {
  top: 13px;
}

.open span:last-of-type {
  bottom: 13px;
}

.open span:nth-child(2) {
  top: 50%;
  margin-top: -1.5px;
}

.close {
  transform: translateY(-100%);
  transition: 1s;
  color: #212c55;
}

[show="true"] .close {
  transform: translateY(0%);
}

@media screen and (max-width: 980px) {
  .menu {
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .menu > div {
    width: 100%;
    height: 50vh;
  }
}

@media screen and (max-width: 768px) {

  header .contenedor-logo {
    width: 115px;
  }

  header.min .contenedor-logo {
    width: 100px;
  }

  /* a.menu-el:last-of-type {
    padding-left: 57.5px;
  } */

  a.menu-el:first-of-type {
    margin: 0;
    margin-bottom: 10px;
    padding-right: 57.5px;
  }
  .menu-el.-dorado {
    margin: 7px 0px;
  }
  .menu-el.router-link-exact-active:first-of-type::before,
  .menu-el[active="true"]:first-of-type::before {
    margin-left: -27.5px;
  }

  .menu-el.router-link-exact-active:last-of-type::before,
  .menu-el[active="true"]:last-of-type::before {
    margin-left: 27.5px;
  }

  /* a.menu-el:first-of-type,
  a.menu-el:last-of-type {
    padding: 0 20px;
  } */

  .menu .opciones {
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    align-items: flex-start;
    -webkit-align-items: flex-start;
    height: 130px;
    padding: 0;
    margin-left: 0;
    margin-top: 50px;
  }
}

@media screen and (max-width: 600px) {
  .contenedor-logo {
    width: 105px !important;
  }
}
@media screen and (max-width: 550px) {
  .menu .white-box {
    width: 100%;
    height: 33vh;
  }

  .menu > div {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/header.vue